/**
 * Pie Passage Config Helpers - used by PiePassageAuthor.vue (new editor).
 */

export interface PiePassageFields {
  title?: string
  subtitle?: string
  author?: string
  text?: string
  teacherInstructions?: string
}

export interface PiePassage {
  title: string
  subtitle: string
  author: string
  text: string
  teacherInstructions: string
}

export function buildPieConfig(passage: PiePassageFields): any {
  return {
    buildInfo: [
      {
        name: '@pie-element/passage',
        version: 'latest',
      },
    ],
    layout: 'layout',
    elements: {
      'pie-passage': '@pie-element/passage@latest',
    },
    models: [
      {
        id: 'p-00000000',
        element: 'pie-passage',
        titleEnabled: true,
        subtitleEnabled: true,
        authorEnabled: true,
        textEnabled: true,
        teacherInstructionsEnabled: true,
        passages: [
          {
            title: passage.title || '',
            subtitle: passage.subtitle || '',
            author: passage.author || '',
            text: passage.text || '',
            teacherInstructions: passage.teacherInstructions || '',
          },
        ],
      },
    ],
    markup: "<pie-passage id='p-00000000'></pie-passage>",
  }
}

/**
 * First passage entry out of a pie passage config.
 */
export function pieFirstPassage(config: any): PiePassage {
  return (
    config?.models?.[0]?.passages?.[0] || { title: '', subtitle: '', author: '', text: '', teacherInstructions: '' }
  )
}
